import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

// Route guard for pages that admins AND view-only demo admins can access.
// Real admin has full write; demo admin sees the same pages read-only.
export default function AdminViewRoute({ children }) {
    const { user, loading, isAdminView } = useAuth();
    if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-500 text-sm">Loading…</div>;
    if (!user) return <Navigate to="/login" replace />;
    if (!isAdminView) return <Navigate to="/dashboard" replace />;
    return children;
}
